/**
 * Busy row for skeleton or spinner regions (text-only baseline).
 *
 * @param label - Visible status line (catalog-backed).
 * @returns **`div`** with **`aria-busy=true`** and **`qz-loading`** class.
 */
export function createLoadingRow(label: string): HTMLDivElement {
  const el = document.createElement("div");
  el.className = "qz-loading";
  el.setAttribute("aria-busy", "true");
  el.setAttribute("aria-live", "polite");
  el.textContent = label;
  return el;
}
